import { Component } from 'react';
import { COLUMNS } from './keys';
import DataTable from '../../../components/Datatable';
import { v4 as uuid } from 'uuid';
import { scrollForTable } from '../../../components/Datatable/utils';
import { withTranslation } from 'react-i18next';

class Table extends Component {
    constructor() {
        super();
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) =>
            search ? item.first_directory?.toLowerCase().includes(search.toLowerCase()) : item,
        );
    }

    render() {
        const { t } = this.props;

        const sortFns = {
            first_directory: (array) =>
                array.sort((a, b) => a.first_directory.localeCompare(b.first_directory)),
            subdomain: (array) => array.sort((a, b) => a.subdomain.localeCompare(b.subdomain)),
            week: (array) => array.sort((a, b) => a.week.localeCompare(b.week)),
            urls: (array) => array.sort((a, b) => a.urls - b.urls),
            clicks: (array) => array.sort((a, b) => a.clicks - b.clicks),
            keywords: (array) => array.sort((a, b) => a.keywords - b.keywords),
            impressions: (array) => array.sort((a, b) => a.impressions - b.impressions),
            position: (array) => array.sort((a, b) => a.position - b.position),
            ctr: (array) => array.sort((a, b) => a.ctr - b.ctr),
        };
        const dataWithKey = this.props.data.map((item) => ({ ...item, id: uuid() }));

        return (
            <>
                <DataTable
                    nodes={dataWithKey}
                    sortFns={sortFns}
                    COLUMNS={COLUMNS(t)}
                    fileName={t('search.directories_details.directory_table.header')}
                    header={t('search.directories_details.directory_table.header')}
                    searchFunction={this.searchFunction}
                    defaultSortKey="clicks"
                    forceRun={this.props.forceRun}
                    additionalStyles={{
                        Table: `
                            --data-table-library_grid-template-columns : minmax(0px, 2fr) minmax(0px, 1fr) minmax(0px, 1fr) minmax(0px, 1fr) minmax(0px, 1fr) minmax(0px, 1fr) minmax(0px, 1fr) minmax(0px, 1fr) minmax(0px, 1fr) !important;
                           ${scrollForTable}
                        `,
                        BaseCell: `  font-family: 'Raleway';
                                    font-weight: 500;
                                    font-size: 16px;
                                    line-height: 19px;
                                    padding: 16px 10px !important;
                                    color: #0D182C;
                                
                                
                                    &.underline {
                                        text-decoration: underline;
                                    }
                                    `,
                    }}
                />
            </>
        );
    }
}

export default withTranslation()(Table);
